// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.booking-details-container {
  padding: 16px;
}
.booking-details-container .section {
  margin-bottom: 16px;
}
.booking-details-container .section .title {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 8px;
}
.booking-details-container .section .label {
  font-weight: 500;
  color: var(--ion-color-medium);
}
.booking-details-container .section .chips-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.booking-details-container ion-chip {
  font-size: 0.9rem;
}`, "",{"version":3,"sources":["webpack://./src/app/booking-details/booking-details.page.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;AACI;EACE,mBAAA;AACN;AACM;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;AACR;AAEM;EACE,gBAAA;EACA,8BAAA;AAAR;AAGM;EACE,aAAA;EACA,eAAA;EACA,QAAA;AADR;AAKI;EACE,iBAAA;AAHN","sourcesContent":[".booking-details-container {\n    padding: 16px;\n  \n    .section {\n      margin-bottom: 16px;\n  \n      .title {\n        font-size: 1.2rem;\n        font-weight: 600;\n        margin-bottom: 8px;\n      }\n  \n      .label {\n        font-weight: 500;\n        color: var(--ion-color-medium);\n      }\n  \n      .chips-row {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 6px;\n      }\n    }\n  \n    ion-chip {\n      font-size: 0.9rem;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
